import type { BrowserAdapters } from './types';

export const browserAdapters: BrowserAdapters = {
  fetch: (input, init) => window.fetch(input, init),
  WebSocket: window.WebSocket,
  location: window.location,
  navigator: window.navigator,
  RTCPeerConnection: window.RTCPeerConnection,
  getUserMedia: (constraints) => navigator.mediaDevices.getUserMedia(constraints),
  createAudio: () => new Audio(),
};
